import React from 'react';
import { Link } from 'react-router-dom';

const Catalogue = () => {
  return (
    <div>
      <div>
        <Link to={'/cake/home'} className="text-decoration-none">
          <button className="btn app-btn-primary mb-3 me-5">&larr; Back</button>
        </Link>
      </div>
      <iframe
        title="Catalogue"
        src={`${process.env.PUBLIC_URL}/PrintreadyfileKantiBakesandflakes.pdf`}
        frameborder="0"
        style={{ display: 'block', width: '100%', height: '100vh' }}
      ></iframe>
    </div>
  );
};

export default Catalogue;
